<template>
  <div class="category_pack_container mobile-min-height">
    <PackCard
      v-for="(pack, index) in packs"
      :title="pack.short_title"
      :perks="pack.perks"
      :image="pack.image"
      :slug="pack.slug"
      :link="getLink(currentGamePackSlug, pack.slug)"
      :is-coming-soon="getComingSoon(pack)"
      :raids="pack?.upcoming_raids || []"
      :index="index"
      :current-game-slug="currentGameSlug"
    />
  </div>
  <WowCustomOrderBanner />

  <div class="d-flex-column justify-start" style="margin-top: 24px">
    <div class="d-flex-column gap-0">
      <p
        class="t-orange regular-l f-w-500 font-family-1"
        style="letter-spacing: 2px"
      >
        {{ $t("homepage.faq") }}
      </p>
      <h2
        class="t-white font-family-1 title-h2 f-w-600"
        style="text-align: center"
      >
        {{ $t("homepage.got_a_question") }}
        <br />
        {{ $t("homepage.we_have")
        }}<span class="t-light-orange">{{ $t("homepage.answers") }}</span
        >!
      </h2>
    </div>
    <div class="d-flex-row align-start lg-row-to-col">
      <div class="d-flex-column">
        <Faq :faqs="[...gameFaqs].splice(0, 3)" variant="pack twocol" />
      </div>
      <div class="d-flex-column">
        <Faq :faqs="[...gameFaqs].splice(3, 6)" variant="pack twocol" />
      </div>
    </div>
  </div>
</template>

<script setup>
import PackCard from "~/components/cards/PackCard.vue";
import WowCustomOrderBanner from "~/components/banners/WowCustomOrderBanner.vue";
import Faq from "~/components/custom/Faq.vue";
import { computed, ref } from "vue";

const { getGame, getGamePack } = useGameStore();
const { currentGamePackSlug, currentGameSlug } = useGameComposable();
const localePath = useLocalePath();
const categorySlug = ref();
const packs = computed(() => {
  if (getGame?.categories?.length > 0) {
    categorySlug.value = currentGamePackSlug;

    const category = getGame.categories?.find(
      (category) => category.slug === currentGamePackSlug
    );
    if (category) {
      if (categorySlug.value === "wow-pve-boost" && category) {
        const customRaidBoost = category?.packs?.find(
          (pack) => pack.slug === "wow-custom-raid-boost"
        );

        if (!customRaidBoost) {
          return category?.packs;
        }

        let reSortPacks = category?.packs?.filter(
          (pack) => pack.slug !== "wow-custom-raid-boost"
        );

        reSortPacks = insertToArray(reSortPacks, 1, customRaidBoost);

        return reSortPacks;
      }
      return category?.packs;
    }
  }
});

const gameFaqs = computed(() => {
  if (getGame?.categories?.length > 0) {
    const category = getGame.categories?.find(
      (category) => category.slug === currentGamePackSlug
    );
    if (category) {
      return category?.faqs;
    }
  }
  return [];
});

const getLink = (passedCategory, packSlug) => {
  if (packSlug === "wow-custom-raid-boost") {
    return `/${currentGameSlug}/${passedCategory}/wow-raid-boost`;
  }
  return localePath(`/${currentGameSlug}/${passedCategory}/${packSlug}`);
};
const getComingSoon = (pack) => {
  if (
    pack.slug === "wow-mounts-unlock" ||
    pack.slug === "wow-transmog-unlock"
  ) {
    return true;
  }
  return false;
};
</script>
